"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _themeBase = require("./themeBase");
const PRIMARY_COLOR = "#003791";
const SECONDARY_COLOR = "#ff4b5f";
const theme = (0, _styles.createTheme)(Object.assign({}, _themeBase.themeBase, {
  palette: {
    primary: {
      main: PRIMARY_COLOR
    },
    secondary: {
      main: SECONDARY_COLOR
    },
    custom: {
      headerPhone: "#a1afbf",
      headerPhoneHint: "#607289",
      footerText1: "#a1afbf",
      footerText2: "#607289",
      storeLinksColor: "#C1C9D2",
      footerBg: "#fff",
      acceptmentCheckbox: PRIMARY_COLOR,
      acceptmentLabel: "inherit"
    }
  },
  overrides: Object.assign({}, _themeBase.themeBase.overrides, {
    MuiButton: Object.assign({}, _themeBase.themeBase.overrides.MuiButton, {
      containedSecondary: {
        "&:hover": {
          backgroundColor: "#EC3449"
        }
      }
    })
  })
}));
if (process.env.NODE_ENV !== "production") {
  console.error('⚠️ Deprecation theme "theme". Use the "/styles/themes/blue" instead');
}
/**
 * @deprecated use /styles/themes/blue instead
 */

var _default = theme;
exports.default = _default;